export const title = 'Súmate al Wall of Love'
export const description =
  'Firma, únete y alza tu voz para cambiar el BullyingXLoving'
